import gql from 'graphql-tag';

import { LINK_PREVIEW_METADATA_FRAGMENT } from '../LinkMetadata/linkPreviewMetadata';
import { LINK_PREVIEW_METADATA_DETAILS_FRAGMENT } from '../LinkMetadataDetails/linkPreviewMetadataDetails';
import { MENTIONS_PLEX_REGISTERED_USER_FRAGMENT } from '../PlexRegisteredUser/mentionsPlexRegistereduser';

export const FEED_ANSWER_FRAGMENT = gql`
  fragment feedAnswer on Answer {
    id
    body
    primaryLink {
      id
      details {
        ...linkPreviewMetadataDetails
      }
    }
    currentUserRelation
    # TODO: remove links if breaking AnswerView into full vs preview
    links {
      ...linkPreviewMetadata
    }
    mentions {
      ...mentionsPlexRegisteredUser
    }
    deleted
  }

  ${LINK_PREVIEW_METADATA_DETAILS_FRAGMENT}
  ${LINK_PREVIEW_METADATA_FRAGMENT}
  ${MENTIONS_PLEX_REGISTERED_USER_FRAGMENT}
`;
